<template>
  <div class="form-group">
    <label for="client">
      {{ $t('users.customer') }}:
    </label>

    <div :class="{ 'form-control': true, 'is-select': true, 'is-loading': !loaded }">
      <v-select
        :options="customers"
        v-model="customer_id"
        :reduce="customer => customer.id"
        :filterBy="filterByForCustomers"
        :placeholder="$t('customer.selectCustomer')"
        label="name"
        @search="debouncedFetchCustomers">
        <template slot="no-options">
          <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
          <template v-if="emptyResults">{{ $t('customer.noCustomerMarchingPhraseFound') }}&hellip;</template>
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.name }} ({{ option.invoice_country_prefix }}{{ option.invoice_tax_number }})
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center">
            {{ option.name }} ({{ option.invoice_country_prefix }}{{ option.invoice_tax_number }})
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-select',
  props: [
    'hasUserToLoad'
  ],
  data () {
    return {
      customer_id: null,
      customers: [],
      emptyResults: false,
      loaded: false
    }
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      method: 'get',
      endpoint: '/customers/items',
      outputKey: 'customers',
      errorKey: 'loadCustomersError',
      successAction: () => {
        if (!this.hasUserToLoad) {
          this.loaded = true;
        }
      }
    });
  },
  methods: {
    filterByForCustomers (option, label, search) {
      return (option.name + ' ' + option.email + ' ' + option.invoice_country_prefix + option.invoice_tax_number).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    loadCustomer (customerID) {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/customers/item/' + parseInt(customerID, 10),
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        wrapResponseIntoArray: true,
        successAction: () => {
          this.customer_id = parseInt(customerID, 10);

          if (this.hasUserToLoad) {
            this.loaded = true;
          }
        }
      });
    },
    fetchCustomers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/customers/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.customer_id !== 0 && this.customer_id !== null && searchPhrase === '') {
        endpointUrl = '/customers/item/' + parseInt(this.customer_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: endpointUrl,
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchCustomers: debounce(function (searchPhrase, loadingCallback) {
      this.fetchCustomers(searchPhrase, loadingCallback);
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.is-loading {
  & > * {
    opacity: .25;
    pointer-events: none;
  }
}
</style>
